export function getSameDayLastYear(timestamp) {
  const date = new Date(timestamp)
  let year = date.getFullYear()
  // 减去年份得到去年的日期
  date.setFullYear(year - 1)
  return date.getTime()
}

export function timeDisabledDate(time, minPickedDate = null, limitMonth = 3) {
  const afterToday = time > new Date()

  if (!minPickedDate) {
    return afterToday
  }

  const minPickedDateCopy = new Date(minPickedDate)
  const year = minPickedDateCopy.getFullYear()
  const month = minPickedDateCopy.getMonth()
  const date = minPickedDateCopy.getDate()
  const min = new Date(year, month - limitMonth, date)
  const max = new Date(year, month + limitMonth, date)

  const inRange = time.getTime() < min || time.getTime() > max

  return afterToday || inRange
}

export const dateFilterType = {
  DAY: 0,
  MONTH: 1,
}

/**
 * 统计页：将已选区间归一到自然日/自然月边界。
 * @param {[Date|string|number, Date|string|number]|null|undefined} range
 * @param {number} dateType 0 按日 / 1 按月
 * @returns {[Date, Date]|[null, null]}
 */
export function normalizeStatisticsDateRange(range, dateType) {
  const [rawStart, rawEnd] = range || []
  if (!rawStart || !rawEnd) return [null, null]
  const startDate = new Date(rawStart)
  const endDate = new Date(rawEnd)
  if (dateType === dateFilterType.MONTH) {
    startDate.setDate(1)
    startDate.setHours(0, 0, 0, 0)
    endDate.setMonth(endDate.getMonth() + 1, 0)
    endDate.setHours(23, 59, 59, 0)
  } else {
    startDate.setHours(0, 0, 0, 0)
    endDate.setHours(23, 59, 59, 0)
  }
  return [startDate, endDate]
}

/**
 * 统计页默认区间。
 * @param {number} dateType 0 按日 / 1 按月
 * @param {'statisticsStandard'|'hardware'} preset
 *   - `statisticsStandard`：按日为「昨日 23:59:59」止，起点为「昨日」往前一个自然月同日 00:00；按月为上一年同月起至当月末
 *   - `hardware`：硬件主筛与导出（按日为「今日往前第 7 天 00:00」至「昨日 23:59:59」；按月同 standard 的按月跨度）
 */
export function getDefaultStatisticsDateRange(dateType, preset = 'statisticsStandard') {
  const now = new Date()
  if (dateType === dateFilterType.MONTH) {
    const startDate = new Date(now.getFullYear() - 1, now.getMonth(), 1, 0, 0, 0)
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 0)
    return [startDate, endDate]
  } else {
    if (preset === 'hardware') {
      const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7, 0, 0, 0)
      const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59, 0)
      return [startDate, endDate]
    }
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59, 0)
    const startDate = new Date(endDate)
    startDate.setMonth(startDate.getMonth() - 1)
    startDate.setHours(0, 0, 0, 0)
    return [startDate, endDate]
  }
}
